module.exports = __webpack_public_path__ + "static/media/Dual_Reflect_8100.abdb1f4c.jpg";